// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3g1W2","col":"styles_col__3TEeZ","fulfillmentStatus":"styles_fulfillmentStatus__2O9dW","emailCol":"styles_emailCol__1oEoX"};